/*
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { StyleSheet } from 'react-native';
import { styles as oneHatStyles } from '../OneHat/styles/styles';
import _ from 'lodash';

// WebView CSS
export const cssReset = `html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:'';content:none}table{border-collapse:collapse;border-spacing:0}`;
export const cssDefault = `
	body {
		font-family: 'Roboto', sans-serif;
		font-size: 10px;
		padding: 25px;
	}
	h1 {
		font-size: 4em;
		font-weight: bold;
		padding: 0 0 0.2em;
		color: #1C5D73;
	}
	h2 {
		font-size: 3.1em;
		font-style: italic;
		padding: 0 0 0.4em;
	}
	h3 {
		font-size: 2.2em;
		font-weight: bold;
		padding: 0 0 0.05em;
	}
	p {
		font-size: 2em;
		line-height: 1.5em;
		color: #666;
		padding: 0 0 1.4em;
	}
	img {
		potision: relative;
		display: block;
		max-width: 100%;
		margin: 0 auto 20px;
	}
	ul {
		list-style: circle;
		padding: 0 0 0.5em 3em;
		margin-top: -2em;
	}
	li {
		font-size: 2em;
		line-height: 1.3em;
		color: #666;
		padding: 0 0 0.2em 0;
	}
	.noteholder sup {
		vertical-align: super;
		font-size: 0.5em;
	}
	.footnote {
		padding: 1.5em;
		background: #dedede;
		border: 1px solid #aaa;
	}
		.footnote .footnote-title {
			font-size: 1.2em;
			font-weight: bold;
			padding: 0 0 2.5em;
		}
		.footnote p {
			font-size: 1.2em;
			padding: 0;
			margin: 0.1em 0;
		}
`;

const width = null,
	maxWidth = null;

export default StyleSheet.create(_.merge({}, oneHatStyles, {
	// container: {
	// 	flex: 1,
	// 	flexGrow: 1,
	// 	justifyContent: 'space-between',
	// 	flexDirection: 'column',
	// 	alignItems: 'center',
	// 	backgroundColor: '#ffc',
	// 	height: '100%',
	// 	width: '100%',
	// 	maxWidth,
	// },
	button: {
		backgroundColor: '#488CA3',
		width,
		maxWidth,
		flexDirection: 'row',
		justifyContent: 'center',
		marginBottom: 10,
	},
		buttonText: {
			color: '#fff',
		},
		buttonIcon: {
			color: '#fff',
		},
	announcementButton: {
		backgroundColor: '#fff',
		borderColor: '#f00',
		borderWidth: 1,
	},
		announcementButtonText: {
			color: '#f00',
		},
		announcementButtonIcon: {
			color: '#F00',
		},
	webview: {
		flex: 1,
	},
	linkContainer: {
		padding: 20,
		paddingTop: 50,
	},
		linkDescription: {
			color: '#000',
			backgroundColor: '#fff',
			marginBottom: 20,
			fontSize: 18,
			textAlign: 'center',
		},
	textContainer: {
		flex: 1,
		flexGrow: 1,
		padding: 30,
	},
		textComponent: {
			color: '#666',
			fontSize: 20,
			lineHeight: 30
		},
	ratingsContainer: {
		flex: 1,
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
		rating: {
			marginTop: 50,
			marginBottom: 50,
		},
	// announcementContainer: {
	// 	height: 150,
	// 	backgroundColor: '#fff',
	// 	borderColor: '#f00',
	// 	borderWidth: 3,
	// 	padding: 20,
	// 	marginRight: 20,
	// 	marginLeft: 20,
	// 	marginBottom: 30,
	// 	alignItems: 'flex-start',
	// },
	// 	announcementTitle: {
	// 		flex: 1,
	// 		fontSize: 17,
	// 		fontWeight: 'bold',
	// 	},
	// 	announcementBody: {
	// 		flex:3,
	// 		fontSize: 14,
	// 	},
}));
